import { BILLS_SUMMARY_TYPE, BILLS_TYPE, GAS_INSTALLATION } from '@spa/shared/constants/billTypes';
import { GLOBAL_BILLS } from '@spa/shared/constants/bills-features';

export const calculateBillsIncluded = (costs, property) => {
  if (!costs?.bills) {
    return BILLS_SUMMARY_TYPE.NONE;
  }

  if (allBillsIncluded(costs, property)) {
    return BILLS_SUMMARY_TYPE.ALL;
  }

  if (someBillsIncluded(costs, property)) {
    return BILLS_SUMMARY_TYPE.SOME;
  }

  return BILLS_SUMMARY_TYPE.NONE;
};

export const allBillsIncluded = (costs, property) => {
  if (!costs?.bills) {
    return false;
  }

  const gasType = property?.main_features?.gas_type || null;

  return getBillsType(gasType).reduce((acc, bill) => {
    return acc && costs.bills[bill]?.included;
  }, true);
};

export const someBillsIncluded = (costs, property) => {
  if (!costs?.bills) {
    return false;
  }

  const gasType = property?.main_features?.gas_type || null;

  return getBillsType(gasType).reduce((acc, bill) => {
    return acc || costs.bills[bill]?.included;
  }, false);
};

export const noBillsIncluded = (costs, property) => {
  return !someBillsIncluded(costs, property);
};

export const getBillsType = (gasType = GAS_INSTALLATION) => {
  return gasType === GAS_INSTALLATION
    ? Object.values(BILLS_TYPE)
    : Object.values(BILLS_TYPE).filter(bill => bill !== BILLS_TYPE.GAS);
};

export const getBills = (costs, property) => {
  if (!costs?.bills || !property?.main_features) {
    return { included: BILLS_SUMMARY_TYPE.NONE };
  }

  const { bills } = costs;
  const included = calculateBillsIncluded(costs, property);

  const gasType = property.main_features.gas_type;
  if (gasType !== GAS_INSTALLATION) {
    const { gas: _, ...billsWithoutGas } = bills;
    return { included, ...billsWithoutGas };
  }

  return { included, ...bills };
};

export const getComponentsFromBills = bills => {
  if (!bills) {
    return { included: [], notIncluded: [] };
  }

  return Object.values(BILLS_TYPE).reduce(
    (acc, key) => {
      if (!bills[key]) {
        return { ...acc };
      }

      bills[key]?.included
        ? (acc.included = [...acc.included, { ...bills[key], ...GLOBAL_BILLS[key] }])
        : (acc.notIncluded = [...acc.notIncluded, { ...bills[key], ...GLOBAL_BILLS[`no-${key}`] }]);

      return { ...acc };
    },
    { included: [], notIncluded: [] }
  );
};

export const getBillsStatus = ({ bills = {} }) =>
  getBillsType(GAS_INSTALLATION).reduce(
    (acc, bill) => ({
      ...acc,
      [bill]: bills[bill]?.included || false
    }),
    {}
  );
